import apiClient from 'auth/FetchInterceptor'

export function isOk(response) {
    return response && response.code >= 200 && response.code < 300;
}

export async function post(endpoint, data) {
    return apiClient
        .post(endpoint, data)
        .then(response => response)
        .catch(error => {
            const { response } = error
            if (response.code && response.message && response.description) {
                return response;
            }
            return false;
        });
}

export async function put(endpoint, data) {
    return apiClient
        .put(endpoint, data)
        .then(response => response || false)
        .catch(error => {
            if (error.code && error.message && error.description) {
                return error;
            }
            return false;
        });
}

export async function patch(endpoint, data) {
    return apiClient
        .patch(endpoint, data)
        .then(response => response || false)
        .catch(error => {
            if (error.code && error.message && error.description) {
                return error;
            }
            return false;
        });
}

export async function del(endpoint) {
    return apiClient
        .delete(endpoint)
        .then(response => response || false)
        .catch(error => {
            if (error.code && error.message && error.description) {
                return error;
            }
            return false;
        });
}

export async function get(endpoint, queryParams) {
    return apiClient
        .get(endpoint, { params: queryParams })
        .then(response => response)
        .catch(error => {
            const { response } = error
            if (response.code && response.message && response.description) {
                return response;
            }
            return false;
        });
}

export async function addFile(endpoint, formData, config, params) {
    return apiClient
        .post(endpoint, formData, {
            params,
            headers: {
                'content-type': 'multipart/form-data',
            },
            ...config,
        })
        .then(response => {
            if (response) {
                return response;
            }
            return false;
        })
        .catch(() => false);
}
